// @ts-nocheck in
import React, { Component, ElementType, HTMLAttributes } from 'react';
import Touch, { TouchEvent, TouchEventHandler, TouchProps } from '../Touch';
import TouchRootContext from '../Touch/context';
import classNames from 'classnames';

import {
  HasRootRef, OldRef, RefWithCurrent
} from '../../../../interfaces';

export interface TappableProps extends HTMLAttributes<HTMLElement>, HasRootRef<HTMLElement> {
  Component?: ElementType;
  activeEffectDelay?: number;
  disabled?: boolean;
  stopPropagation?: boolean;
  href?: string;
  target?: string;
}

export interface TappableState {
  clicks?: {
    [index: string]: {
      x: number;
      y: number;
    };
  };
  active?: boolean;
  ts?: number;
}

export interface RootComponentProps extends TouchProps {
  ref?: OldRef<HTMLElement> | RefWithCurrent<HTMLElement>;
}

export interface StorageItem {
  activeTimeout: number;
  timeout?: number;
  stop(): void;
}

export interface Storage {
  [index: string]: StorageItem;
}

export type GetStorage = () => StorageItem;

const ts = () => +Date.now();

export const ACTIVE_DELAY = 70;
export const ACTIVE_EFFECT_DELAY = 600;

const storage: Storage = {};

/*
 * Очищает таймауты и хранилище для всех экземпляров компонента, кроме переданного
 */
function deactivateOtherInstances(exclude?: string) {
  Object.keys(storage).filter((id: string) => id !== exclude).forEach((id: string) => {
    clearTimeout(storage[id].activeTimeout);
    clearTimeout(storage[id].timeout);
    storage[id].stop();

    delete storage[id];
  });
}

class Index extends Component<TappableProps, TappableState> {
  constructor(props: TappableProps) {
    super(props);
    this.id = Math.round(Math.random() * 1e8).toString(16);
    this.state = {
      clicks: {},
      active: false,
      // @ts-ignore
      ts: null,
    };
    this.isSlide = false;
  }

  id: string;

  isSlide: boolean;
  // @ts-ignore
  insideTouchRoot: boolean;
  // @ts-ignore
  container: HTMLElement;
  // @ts-ignore
  timeout: number;
  // @ts-ignore
  wavesTimeout: number;

  static defaultProps: TappableProps = {
    Component: 'div',
    role: 'button',
    stopPropagation: false,
    disabled: false,
    activeEffectDelay: ACTIVE_EFFECT_DELAY,
  };

  /*
   * Обрабатывает событие touchstart
   */
  // eslint-disable-next-line react/sort-comp
  onStart: TouchEventHandler = ({ originalEvent }: TouchEvent) => {
    // eslint-disable-next-line react/destructuring-assignment,no-unused-expressions
    !this.insideTouchRoot && this.props.stopPropagation && originalEvent.stopPropagation();
    if (originalEvent.touches && originalEvent.touches.length > 1) {
      deactivateOtherInstances();
      return;
    }

    storage[this.id] = {
      stop: this.stop,
      activeTimeout: window.setTimeout(this.start, ACTIVE_DELAY),
    };
  };

  /*
   * Обрабатывает событие touchmove
   */
  onMove: TouchEventHandler = ({ originalEvent, shiftXAbs, shiftYAbs }: TouchEvent) => {
    // eslint-disable-next-line react/destructuring-assignment,no-unused-expressions
    !this.insideTouchRoot && this.props.stopPropagation && originalEvent.stopPropagation();
    // @ts-ignore
    if (shiftXAbs > 20 || shiftYAbs > 20) {
      this.isSlide = true;
      this.stop();
    }
  };

  /*
   * Обрабатывает событие touchend
   */
  onEnd: TouchEventHandler = ({ originalEvent }: TouchEvent) => {
    // eslint-disable-next-line react/destructuring-assignment,no-unused-expressions
    !this.insideTouchRoot && this.props.stopPropagation && originalEvent.stopPropagation();
    const now = ts();

    if (originalEvent.touches && originalEvent.touches.length > 0) {
      this.isSlide = false;
      return;
    }

    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.active) {
      // eslint-disable-next-line react/destructuring-assignment
      if (now - this.state.ts >= 100) {
        // Долгий тап, выключаем подсветку
        this.stop();
      } else {
        // Короткий тап, оставляем подсветку

        const timeout = window.setTimeout(
          // @ts-ignore
          this.stop, this.props.activeEffectDelay - now + this.state.ts
        );
        const store = this.getStorage();

        if (store) {
          store.timeout = timeout;
        }
      }
    } else if (!this.isSlide) {
      // Очень короткий тап, включаем подсветку
      this.start();

      const timeout = window.setTimeout(this.stop, this.props.activeEffectDelay);

      if (this.getStorage()) {
        clearTimeout(this.getStorage().activeTimeout);
        this.getStorage().timeout = timeout;
      } else {
        this.timeout = timeout;
      }
    }

    this.isSlide = false;
  };

  /*
   * Устанавливает активное выделение
   */
  start: VoidFunction = () => {
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.state.active) {
      this.setState({
        active: true,
        ts: ts(),
      });
    }
    deactivateOtherInstances(this.id);
  };

  /*
   * Снимает активное выделение
   */
  stop: VoidFunction = () => {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.active) {
      this.setState({
        active: false,
        // @ts-ignore
        ts: null,
      });
    }
    if (this.getStorage()) {
      clearTimeout(this.getStorage().activeTimeout);
      delete storage[this.id];
    }
  };

  /*
   * Возвращает хранилище для экземпляра компонента
   */
  getStorage: GetStorage = () => {
    return storage[this.id];
  };

  /*
   * Берет ref на DOM-ноду из экземпляра Touch
   */
  getRef: OldRef<HTMLElement> = (container: HTMLElement) => {
    this.container = container;

    const { getRootRef } = this.props;
    if (getRootRef) {
      if (typeof getRootRef === 'function') {
        getRootRef(container);
      } else {
        getRootRef.current = container;
      }
    }
  };

  componentWillUnmount() {
    if (storage[this.id]) {
      clearTimeout(storage[this.id].timeout);
      clearTimeout(storage[this.id].activeTimeout);

      delete storage[this.id];
    }

    clearTimeout(this.wavesTimeout);
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { clicks, active } = this.state;
    const {
      // eslint-disable-next-line no-shadow
      children, className, Component, activeEffectDelay,
      // @ts-ignore
      stopPropagation, getRootRef, platform, ...restProps
    } = this.props;

    const classes = classNames('Tappable Tappable--ios', className, {
      // @ts-ignore
      'Tappable--active': active,
      'Tappable--inactive': !active,
    });

    const RootComponent = !restProps.disabled ? Touch : Component;
    const props: RootComponentProps = {};
    if (!restProps.disabled) {
      props.Component = Component;
      /* eslint-disable */
      props.onStart = this.onStart;
      props.onMove = this.onMove;
      props.onEnd = this.onEnd;
      /* eslint-enable */
      props.getRootRef = this.getRef;
    } else {
      props.ref = this.getRef;
    }

    return (
      <TouchRootContext.Consumer>
        {(insideTouchRoot: boolean) => {
          this.insideTouchRoot = insideTouchRoot;

          return (
            <RootComponent {...restProps} className={classes} {...props}>
              {children}
            </RootComponent>
          );
        }}
      </TouchRootContext.Consumer>
    );
  }
}

export default Index;
